/*eslint-disable */
import Quiz from '../contestQuizzort/index';
import { bus } from '@/main';
var $ = window.jQuery = jQuery = require('jquery');
export default {
  name: 'contest-info-page',
  components: {
    'quiz-format': Quiz
  },
  data() {
    return {
      quizDetails: null,
      totalTime: 0,
      quizZ: {
        sections: []
      },
      contestDetailsById:null,
      contestConfirmClosed:false
    }
  },
  computed: {

  },
  mounted() {
    this.detectDevTools();
    $('body').addClass('user_quiz_popup_active');
    $('.courseloader').show();
    this.$store.dispatch('getIvContestInfoByIdAction', {id:this.$route.params.contestId}).then((res) => {
      this.contestDetailsById = res.data
      if(this.contestDetailsById){
        this.totalTime = this.contestDetailsById.time_limit
        this.quizZ.sections = this.contestDetailsById.sections;
        this.quizDetails = this.contestDetailsById;
      }
      $('.courseloader').hide();
    })
    // Disable right-click
    document.addEventListener('contextmenu', (e) => e.preventDefault());

    function ctrlShiftKey(e, keyCode) {
      return e.altKey && e.metaKey && e.keyCode || e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    }

    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (
        event.keyCode === 123 ||
        ctrlShiftKey(e, 'I') ||
        ctrlShiftKey(e, 'J') ||
        ctrlShiftKey(e, 'C') ||
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
      )
        return false;
    };
  },
  methods: {
    detectDevTools() {
      const threshold = 160; // Set a threshold value
      const check = () => {
        const widthThreshold = window.outerWidth - window.innerWidth > threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > threshold;
        if (widthThreshold || heightThreshold) {
          // DevTools might be open, you can take action here
          alert('DevTools is open!');
        }
      };
      setInterval(check, 1000); // Check for DevTools every second
    },
    preventContextMenu(e) {
      if (e.key == 123) {
        e.preventDefault();
      }
      if (e.ctrlKey && e.shiftKey && e.key == 'I') {
          e.preventDefault();
      }
      if (e.ctrlKey && e.shiftKey && e.key == 'C') {
          e.preventDefault();
      }
      if (e.ctrlKey && e.shiftKey && e.key == 'J') {
          e.preventDefault();
      }
      if (e.ctrlKey && e.key == 'U') {
          e.preventDefault();
      }
    },
    contestConfirmOpenedfun(){
      this.contestConfirmClosed = true
      $('body').addClass("contentQuizBody")
    },
    contestConfirmClosedfun(){
      this.contestConfirmClosed = false
      $('body').removeClass("contentQuizBody")
    },
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('user_quiz_popup_active');
    $('body').removeClass("contentQuizBody")
    next();
  },
  beforeDestroy() {
    // Remove other event listeners if you added them
    // window.removeEventListener("keydown", this.checkDevTools);
  },
}